<template>
  <v-row class="my-0">

    <!-- full mode ( standalone page) -->
    <template v-if="!gallery">

      <seo-v-img :src="require('../assets/img/header-background.jpg').default" :aspect-ratio="3589/1334" class="mb-8" width="100%" :max-width="$vuetify.breakpoint.mdAndUp ? '80%' : '100%'" contain>
        <v-row align="center" class="fill-height" no-gutters>
          <v-col cols="12" class="text-h4 text-md-h1 text-uppercase pa-8 pa-md-16 font-family-heading text-center">Favorites</v-col>
        </v-row>
      </seo-v-img>
      <v-col cols="12" md="9" class="mx-md-auto">
         <talk-big-card v-for="talk in favoriteEvents" :key="talk.id" :list-data="talk" class="mb-8" />
      </v-col>
    </template>

    <!-- gallery mode-->
    <template v-else-if="gallery && favoriteEvents.length > 0">
      <v-col cols="12"><h1 class="text-h2 mx-4">Favorites</h1></v-col>
      <v-col class="px-4">
        <ScrollGallery
          :data="favoriteEvents"
          :cols="$vuetify.breakpoint.xl ? 3 : $vuetify.breakpoint.lgAndUp ? 4 : $vuetify.breakpoint.mdAndUp ? 5 : $vuetify.breakpoint.smAndUp ? 8 : 10" />
      </v-col>
      <!-- <v-col v-else cols="12">
        <v-row align="center" justify="center" class="fill-height">
          <v-col cols="auto"><v-progress-circular indeterminate /></v-col>
        </v-row>
      </v-col> -->
    </template>
  </v-row>
</template>

<script>
import ScrollGallery from '@/molecules/ScrollGallery'
// import ListWorkshopsByTopic from '@/graphql/ListWorkshopsByTopic.gql'
// import ListTalksByTopic from '@/graphql/ListTalksByTopic.gql'
// import uniqBy from 'lodash/uniqBy'
// import intersectionBy from 'lodash/intersectionBy'
// import TalkCard from '@/molecules/TalkCard'
import TalkBigCard from '@/molecules/TalkBigCard.vue'

export default {
  name: 'FavoriteEvents',
  components: {
    ScrollGallery,
    // TalkCard,
    TalkBigCard
  },
  props: {
    gallery: {
      type: Boolean,
      required: false,
      default: false
    }
  },

  computed: {
    favoriteEvents () {
      return this.$root.databaseUser.favoriteTalks
    }
  }
}
</script>
